import { render, staticRenderFns } from "./TabSelector.vue?vue&type=template&id=a746fd1c&scoped=true&"
import script from "./TabSelector.vue?vue&type=script&lang=js&"
export * from "./TabSelector.vue?vue&type=script&lang=js&"
import style0 from "./TabSelector.vue?vue&type=style&index=0&id=a746fd1c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a746fd1c",
  null
  
)

export default component.exports